// zipcode-checker.js
(function () {
  const ASSET_URL = '/assets/pincodes.json'; // Shopify will serve assets from /assets/
  const CACHE_KEY = 'shop_pincodes_v1';
  const CACHE_TTL_MS = 1000 * 60 * 60 * 24 * 7; // 7 days

  // utility
  function el(id) { return document.getElementById(id); }
  function setMsg(msgEl, text, color) {
    msgEl.textContent = text;
    if (color) msgEl.style.color = color;
  }

  // load pincodes from localStorage or fetch
  async function loadPincodes() {
    try {
      const cached = localStorage.getItem(CACHE_KEY);
      if (cached) {
        const parsed = JSON.parse(cached);
        if (Date.now() - parsed.t < CACHE_TTL_MS && parsed.data) {
          return parsed.data;
        }
      }
      // fetch file from assets
      const resp = await fetch(ASSET_URL, { cache: 'no-store' });
      if (!resp.ok) throw new Error('Failed to fetch pincodes.json');
      const json = await resp.json();
      // store as map (for memory efficiency use object keys)
      localStorage.setItem(CACHE_KEY, JSON.stringify({ t: Date.now(), data: json }));
      return json;
    } catch (err) {
      // If fetch fails, return null to allow API fallback
      console.warn('Pincode load error:', err);
      return null;
    }
  }

  // Optional API fallback (Google Maps geocoding). Enable only if you provide API_KEY.
  async function verifyWithGeocodeAPI(pincode, apiKey) {
    if (!apiKey) return false;
    try {
      const url = `https://maps.googleapis.com/maps/api/geocode/json?components=postal_code:${encodeURIComponent(pincode)}|country:IN&key=${apiKey}`;
      const r = await fetch(url);
      if (!r.ok) return false;
      const data = await r.json();
      if (data.status === 'OK' && data.results && data.results.length) {
        // Could verify locality / administrative_area_level_1 from results[0].address_components
        return true;
      }
      return false;
    } catch (e) {
      console.warn('Geocode API error', e);
      return false;
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    const btn = el('zipcode-btn');
    const input = el('zipcode-input');
    const msg = el('zipcode-message');

    // load in background (starts fetch & caches)
    let pincodesPromise = loadPincodes();

    btn.addEventListener('click', async function () {
      const zipcode = (input && input.value || '').trim();

      // basic format check
      if (!/^[1-9][0-9]{5}$/.test(zipcode)) {
        setMsg(msg, '❌ Please enter a valid 6-digit Indian Pincode.', 'red');
        return;
      }

      // Wait for pincodes dataset (or null)
      const pincodes = await pincodesPromise;

      // 1) If dataset present — direct lookup (fast & reliable)
      if (pincodes) {
        if (pincodes.hasOwnProperty(zipcode)) {
          // found: optional city/state display
          const info = pincodes[zipcode];
          const place = (info && (info.city || info.state)) ? ` (${info.city || ''}${info.city && info.state ? ', ' : ''}${info.state || ''})` : '';
          setMsg(msg, `✅ DELIVERED IN 7 - 12 BUSINESS DAYS.${place}`, 'green');
        } else {
          setMsg(msg, '❌ Invalid or unassigned Indian Pincode.', 'red');
        }
        return;
      }

      // 2) If dataset couldn't load, fallback to Geocoding API (if you have an API key)
      // NOTE: Add your API key string here if you want to use fallback.
      const GOOGLE_MAPS_API_KEY = ''; // <-- put API key here if you want fallback
      if (GOOGLE_MAPS_API_KEY) {
        setMsg(msg, 'Checking pincode (live)...', 'black');
        const ok = await verifyWithGeocodeAPI(zipcode, GOOGLE_MAPS_API_KEY);
        if (ok) {
          setMsg(msg, '✅ DELIVERED IN 7 - 12 BUSINESS DAYS.', 'green');
        } else {
          setMsg(msg, '❌ Invalid or unassigned Indian Pincode.', 'red');
        }
        return;
      }

      // 3) Last-resort heuristic (if no dataset and no API): reject and ask to retry later
      setMsg(msg, '⚠️ Validation currently unavailable. Please try again later or contact support.', 'orange');
    });

    // UX: optionally validate on blur/enter
    input && input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); btn.click(); }
    });
  });
})();
